import { z } from "zod";

const channel = z.number().min(0).max(100);
export const importedPaintSchema = z
  .object({
    rgb: z.string().regex(/^#[a-f0-9]{6}$/),
    cmyk: z.tuple([channel, channel, channel, channel]),
  })
  .strict();
export type ImportedPaint = z.infer<typeof importedPaintSchema>;
export function importedPaintAttribute(paint: ImportedPaint): string {
  return `${paint.cmyk.join(",")};${paint.rgb}`;
}
export function parseImportedPaintAttribute(
  value: string,
): ImportedPaint | undefined {
  const match = /^([0-9.eE+,-]+);(#[a-f0-9]{6})$/.exec(value);
  if (!match) return;
  const parsed = importedPaintSchema.safeParse({
    rgb: match[2],
    cmyk: match[1].split(",").map(Number),
  });
  return parsed.success ? parsed.data : undefined;
}
